import type {ReactElement} from 'react';
import styles from './qr-field-row.module.scss';
import type {QRFieldRowProps} from './qr-field-row.types';

export function QRFieldRow({children}: QRFieldRowProps): ReactElement {
  return <div className={styles.qrFieldRow}>{children}</div>;
}
